/**
 * WP-V2-WC — typy silnika świata + kamery.
 * Kontrakt konsumowany przez sceny (Town/Garden/wnętrza).
 * Zero zależności od avatar/interact.
 */

/** Prostokąt kolizji / strefy (lewy-górny róg + wymiary). */
export type ColliderRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

/** Bounds ruchu w świecie. */
export type WorldMoveBounds = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
};

/**
 * Cel napędzany przez WalkController.
 * Przyjmuje AnimatedDogAvatar lub dowolny mock z tym samym kształtem.
 */
export type WalkableTarget = {
  /** Intencja tap-to-move (cel). */
  moveTo(x: number, y: number): void;
  /** Prędkość ciągła (WASD / przytrzymanie). */
  setVelocity(vx: number, vy: number): void;
  /** Kontener pozycji w świecie (Phaser Container lub mock). */
  container: { x: number; y: number; setPosition?: (x: number, y: number) => void };
};

/** Landmark na minimapie. */
export type MinimapLandmark = {
  id: string;
  x: number;
  y: number;
  /** Kolor kropki (0xRRGGBB). */
  color?: number;
  labelPl?: string;
};

/** Strefa przejścia przy krawędzi. */
export type EdgeZone = {
  id: string;
  rect: ColliderRect;
  /** Klucz sceny / dzielnicy docelowej (opcjonalnie). */
  targetKey?: string;
  labelPl?: string;
};

export type DeadzoneSize = {
  width: number;
  height: number;
};

export const DEFAULT_FOLLOW_LERP = 0.12;
export const DEFAULT_DEADZONE: DeadzoneSize = { width: 120, height: 80 };
export const DEFAULT_AGENT_RADIUS = 22;
/** Domyślna prędkość chodu (px/s) — zgodna z DOG_SPEED w shared. */
export const DEFAULT_WALK_SPEED = 180;
